import React, { useRef, useState } from 'react'
import { Box, Button, Slide, Typography } from '@mui/material'
import { UseUserNotificationsReturnType } from '../../../../hooks/useUserNotifications'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import NotificationCard from './components/notificationCard/NotificationCard'
import NotificationTypeFilterSelect from './components/notificationTypeFilterSelect/NotificationTypeFilterSelect'
import { useTranslation } from 'react-i18next'
import { NotificationData, NotificationDataType } from 'src/api'

interface Props extends UseUserNotificationsReturnType {
  open: boolean
  onClose?: () => void
}

const NotificationDropdown: ReactFC<Props> = ({
  open,
  notifications,
  notificationOpenInstructions,
  notificationIcons,
  closeNotification,
  closeAllNotifications,
  onClose,
  notificationTypeLabels
}) => {
  const { t } = useTranslation()
  const notificationContainerEl = useRef()
  const [notificationTypeFilter, setNotificationTypeFilter] =
    useState<NotificationDataType>()
  const dropdownEl = useRef()

  const handleOpenNotification = (notification: NotificationData) => {
    notificationOpenInstructions[notification.type](notification)
  }

  const handleCloseNotification = (notification: NotificationData) => {
    closeNotification(notification)
  }

  const handleCloseAllNotifications = () => {
    onClose?.()
    setTimeout(() => {
      closeAllNotifications()
    }, 300)
  }

  const notificationsToShow = notificationTypeFilter
    ? notifications.filter(
        (notification) => notification.type === notificationTypeFilter
      )
    : notifications

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        right: 6,
        transform: 'translateY(-100%)'
      }}
      ref={dropdownEl}
    >
      <Slide direction='left' in={open} unmountOnExit>
        <Box
          sx={{
            height: 604,
            maxHeight: '80vh',
            width: 490,
            position: 'relative',
            flexDirection: ' column',
            display: 'flex',
            placeItems: 'center',
            backgroundColor: 'background.paper',
            borderRadius: 2,
            overflow: 'hidden',
            boxShadow: 2
          }}
        >
          <Box
            sx={{
              width: '100%',
              padding: '.5rem 1rem',
              display: 'flex',
              alignItems: 'center',
              position: 'fixed',
              top: 0,
              left: 0,
              backgroundColor: 'background.paper',
              borderRadius: '.5rem .5rem 0 0',
              zIndex: 600
            }}
          >
            <Typography
              component={'span'}
              sx={{
                fontWeight: 500
              }}
            >
              {t('labels.Notifications')}
            </Typography>
            <NotificationTypeFilterSelect
              notificationTypeLabels={notificationTypeLabels}
              notificationType={notificationTypeFilter}
              onChangeNotificationType={(notificationType) =>
                setNotificationTypeFilter(notificationType)
              }
            />
            <Button
              endIcon={<CheckCircleOutlineIcon />}
              sx={{
                color: 'black',
                marginLeft: 'auto'
              }}
              size='small'
              onClick={handleCloseAllNotifications}
            >
              {t('desktop.buttons.Mark_all_notifications_as_read')}
            </Button>
          </Box>
          <Box
            sx={{
              width: '100%',
              maxWidth: '100%',
              marginTop: '3rem',
              overflowY: 'auto',
              overflowX: 'hidden',
              '& > *:not(:first-of-type)': {
                borderTop: ({ palette }) => `1px solid ${palette.border.main}`
              }
            }}
            ref={notificationContainerEl}
          >
            {notificationsToShow.map((notification) => (
              <NotificationCard
                key={notification.id}
                notification={notification}
                icon={notificationIcons[notification.type]}
                onNotificationOpen={handleOpenNotification}
                onNotificationClose={handleCloseNotification}
                containerEl={notificationContainerEl.current!}
              />
            ))}
          </Box>
        </Box>
      </Slide>
    </Box>
  )
}
export default NotificationDropdown
